import CalendarTodayRoundedIcon from "@mui/icons-material/CalendarTodayRounded";
import MenuRoundedIcon from "@mui/icons-material/MenuRounded";
import { Box, Chip, IconButton, Stack } from "@mui/material";
import Popover from "@mui/material/Popover";
import { DateCalendar } from "@mui/x-date-pickers/DateCalendar";
import dayjs from "dayjs";
import "dayjs/locale/en";
import "dayjs/locale/es";
import "dayjs/locale/pt";
import localizedFormat from "dayjs/plugin/localizedFormat";
import moment from "moment";
import * as React from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { StoreInterfaces } from "../../types/store/StoreInterfaces";
import { Breadcrumb } from "../Breadcrumb";
import NotificationMenu from "./Menus/NotificationMenu";
import SideMenuMobile from "./SideMenu/SideMenuMobile";
dayjs.extend(localizedFormat);

export default function Header() {
  const session = useSelector((state: StoreInterfaces) => state.session);
  const [mobileOpen, setMobileOpen] = React.useState(false);

  const { i18n } = useTranslation();

  const locale = i18n.language.split("-")[0];
  moment.locale(locale);
  const today = moment().locale(locale).format("LL");
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);

  const handleOpenCalendar = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleCloseCalendar = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);

  return (
    <Stack
      direction="row"
      sx={{
        width: "100%",
        alignItems: "center",
        justifyContent: "space-between",
        pt: 2,
        pb: 1,
      }}
    >
      <Box sx={{ minWidth: 0 }}>
        <Breadcrumb />
      </Box>

      <Stack
        direction="row"
        spacing={1}
        alignItems="center"
        sx={{ display: { xs: "none", md: "flex" } }}
      >
        <Chip
          icon={React.cloneElement(<CalendarTodayRoundedIcon />, {
            sx: { fontSize: "1.1rem" },
          })}
          label={today}
          variant="outlined"
          clickable
          onClick={handleOpenCalendar}
          sx={{
            borderRadius: 2,
            fontWeight: 600,
            px: 1,
            border: (theme) => `2px solid ${theme.palette.divider}`,
          }}
        />
        <Popover
          open={open}
          anchorEl={anchorEl}
          onClose={handleCloseCalendar}
          anchorOrigin={{
            vertical: "bottom",
            horizontal: "right",
          }}
          transformOrigin={{
            vertical: "top",
            horizontal: "right",
          }}
        >
          <DateCalendar value={moment()} readOnly />
        </Popover>

        {session?.accessToken && <NotificationMenu />}
      </Stack>

      {/* Mobile */}
      <IconButton
        onClick={() => setMobileOpen(true)}
        sx={{
          display: { xs: "inline-flex", md: "none" },
          borderRadius: 2,
        }}
      >
        <MenuRoundedIcon />
      </IconButton>

      <SideMenuMobile open={mobileOpen} onClose={() => setMobileOpen(false)} />
    </Stack>
  );
}
